<div class="generalDiv">
    <div class="recover-bg">
      <app-background></app-background>
      <div class="recover-box">
        <!-- Logo -->
        <div class="recover-logo">
          <img src="Logo.svg" alt="Logo" class="auth-logo">
        </div>
    
        <!-- Título -->
        <p class="recover-text">Recuperar contraseña</p>
    
        <div class="recover-container">
          <p class="recover-info">Se enviara una solicitud a un administrador contáctate con el para actualizar tu contraseña.</p>
        </div>
        <div>
            <p class="recover-info font-semibold">Correo</p>
        </div>
        <div>
            <input type="text" id="email" class="recover-input" placeholder="Ingresar Correo" [(ngModel)]="emailModel">
        </div>
        <!-- Botón -->
        <button type="submit" class="recover-btn" (click)="showValues()">
            Solicitar
          </button>

        <div class="flex flex-col items-center">
            <!-- Línea gris centrada -->
            <div class="recoverGrayLineBorder"> 
            </div>
        
            <!-- Botón Iniciar Sesión -->
            <div class="recoverLoginButton">
                <a [routerLink]="['/auth']">Iniciar Sesión</a>
            </div>
        </div>
    </div>
  </div>
</div>
    
